import React from 'react';

function FollowUs() {
  return (
    <section className="follow-us" id="follow">
      <div className="follow-inner">
        <div className="social-icons">
          <a href="#follow" className="social-icon fb" aria-label="Facebook">f</a>
          <a href="#follow" className="social-icon ig" aria-label="Instagram">📷</a>
        </div>
        <p className="hashtag">#christforindia</p>
        <h2 className="section-title script orange">Follow Us</h2>
        <div className="dots orange-dots">• • • • • • •</div>
      </div>
    </section>
  );
}

export default FollowUs;
